import { render, staticRenderFns } from "./ShareSchedule.vue?vue&type=template&id=c2bb04c6&scoped=true&"
import script from "./ShareSchedule.vue?vue&type=script&lang=js&"
export * from "./ShareSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bb04c6",
  null
  
)

export default component.exports